import React from 'react'
import { inject, observer } from 'mobx-react'

import { CustomSelect } from '../../components/select'

export const CompanySelector = inject('companiesStore')(observer(({companiesStore,...props}) =>
<CustomSelect {...props}
  options={companiesStore.options}
/>))
